exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AuthCount-module__container--1cTTg {\r\n  width: 100%;\r\n  padding: 0px 16px;\r\n  box-sizing: border-box;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.AuthCount-module__titleContainer--27j1k {\r\n  padding: 16px 0px;\r\n  width: 100%;\r\n  border-bottom: 1px solid #dddddd;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.AuthCount-module__title--3M3Hr {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: #333333;\r\n}\r\n\r\n.AuthCount-module__content--ceTNb {\r\n  width: 100%;\r\n  padding: 24px 0px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.AuthCount-module__authImage--cqNhz {\r\n  width: 100px;\r\n  height: 100px;\r\n}\r\n\r\n.AuthCount-module__countImage--1X5sI {\r\n  width: 205px;\r\n  height: 40px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "AuthCount-module__container--1cTTg",
	"titleContainer": "AuthCount-module__titleContainer--27j1k",
	"title": "AuthCount-module__title--3M3Hr",
	"content": "AuthCount-module__content--ceTNb",
	"authImage": "AuthCount-module__authImage--cqNhz",
	"countImage": "AuthCount-module__countImage--1X5sI"
};